// extracted by mini-css-extract-plugin
export default {"price_sale":"css-vI+4zyCbwk","price__cart":"css-ybPIi4ISKb"};